"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.scheduleAtInterval = void 0;
/*
 * @param {number} interval - number of milliseconds to wait after a task is completed
 */
const scheduleAtFixedRate_1 = require("./scheduleAtFixedRate");
const scheduleAtInterval = async (task, interval, executeAtStart) => {
    if (executeAtStart) {
        await task();
    }
    return (0, scheduleAtFixedRate_1.repeatScheduleTask)((doneCb) => {
        return setTimeout(async () => {
            await task();
            doneCb();
        }, interval);
    });
};
exports.scheduleAtInterval = scheduleAtInterval;
//# sourceMappingURL=scheduleAtInterval.js.map